import type { MeContext } from '@vizit/api';
import { ROLE, SCOPE_TYPE } from '../constants';
import { getAccessiblePortfolios, getAccessibleWorkspaces } from './get-accessible';
import { hasGrant } from './grants';
import { isOrgAdmin } from './is-org-admin';

// Client-side gating is not a security boundary — the BE enforces access on every call.
export function canAccessPortfolio(context: MeContext, portfolioId: string): boolean {
  if (isOrgAdmin(context)) {
    return true;
  }

  if (hasGrant(context, ROLE.PortfolioAdmin, SCOPE_TYPE.Portfolio, portfolioId)) {
    return true;
  }

  return getAccessiblePortfolios(context).some((node) => node.id === portfolioId);
}

export function canAccessWorkspace(context: MeContext, workspaceId: string): boolean {
  if (isOrgAdmin(context)) {
    return true;
  }

  if (getAccessibleWorkspaces(context).some((node) => node.id === workspaceId)) {
    return true;
  }

  return hasGrant(context, ROLE.WorkspaceUser, SCOPE_TYPE.Workspace, workspaceId);
}
